module.exports = __webpack_public_path__ + "src/img/warnTag.a24c4920.svg";